module.exports = __webpack_public_path__ + "img/icon_sportMenu_handball.0c34f512.svg";